export const MAIN_BLUE_COLOR = '#2E60CA';//#2E60CA//#3960b4

export const MAIN_RED_COLOR = '#f40266';

export const MAIN_BORDER_COLOR = '#DDE4EA';
